import { render } from "./OwnMedia.vue?vue&type=template&id=09a3f256&scoped=true"
import script from "./OwnMedia.vue?vue&type=script&lang=js"
export * from "./OwnMedia.vue?vue&type=script&lang=js"

import "./OwnMedia.vue?vue&type=style&index=0&id=09a3f256&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a3f256"]])

export default __exports__